import {
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
} from "@mui/material";
import React from "react";
import { ModalWrapper } from "components/modalWrapper";
import { CheckCircleIcon } from "components/CheckCircleIcon";

export interface CorpExpensesModalProps {
  open: boolean;
  onClose: () => void;
}

export const CorpExpensesModal = (props: CorpExpensesModalProps) => {
  const corpExpensesList = [
    "Adiantamento de saldo corporativo",
    "Aprovação ou reprovação de reembolsos",
    "Pagamento coletivo",
    "Visualização de extrato detalhado",
    "Cartão virtual e físico"
  ]
  return (
    <ModalWrapper
      title="Despesas corporativas na Caju"
      subtitle="Gerencie reembolsos e adiantamento de saldo corporativo em poucos cliques para evoluir na gestão de despesas e controle de gastos, por meio do cartão Caju."
      open={props.open}
      handleClose={props.onClose}
    >
      <Paper variant="outlined" sx={{ p: 3, borderRadius: '20px' }}>
        <Typography variant="subtitle2" color="dark.dark" marginBottom={2}>
          Funcionalidades e benefícios:
        </Typography>
        <List>
          {corpExpensesList.map((benefit, index) => (
            <ListItem key={index} sx={{ py: '6px' }}>
              <ListItemIcon>
                <CheckCircleIcon />
              </ListItemIcon>
              <ListItemText
                primary={benefit}
                primaryTypographyProps={{
                  fontSize: 14,
                  color: "dark.light",
                }}
              />
            </ListItem>
          ))}
        </List>
      </Paper>
    </ModalWrapper>
  );
};
